import { useDispatch } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';

const Picker = ({ currentOption, options, action }) => {
    const dispatch = useDispatch();
    let option = [...options].map((elm) => {
        let label = elm.replace('Cables', '');
        if (currentOption === elm) {
            return (
                <Button
                    className={buttons.btnPillActive}
                    disableRipple={true}
                    variant="contained"
                    key={elm}
                    onClick={() => {
                        dispatch(action(elm));
                    }}>
                    {label}
                </Button>
            );
        } else {
            return (
                <Button
                    disableRipple={true}
                    key={elm}
                    variant="outlined"
                    className={buttons.btnPill}
                    onClick={() => {
                        dispatch(action(elm));
                    }}>
                    {label}
                </Button>
            );
        }
    });
    return (
        // <ToggleButtonGroup style={{ backgroundColor: "white" }}>{option}</ToggleButtonGroup>
        <Box className={layout.btnContainer}>{option}</Box>
    );
};

export default Picker;
